module.exports = __webpack_public_path__ + "img/partner12.412734c0.png";